<template>
    <div class="inner-box">
        <!-- 검색폼 s-->
        <el-form ref="form" :model="form" label-width="80px" size="mini">
            <el-row>
                <el-col :span="10">
                    <el-form-item label="상담유형">
                        <el-select class="select" v-model="form.callClass" placeholder="상담유형을 선택하세요." :disabled="bReadOnly" @change="onCallClassChange0" >
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in callClassOpt"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="14">
                    <el-form-item label="상담분류">
                        <el-select v-model="form.callCatId1" placeholder="상담분류(대)" @change="onCallClassChange1" :disabled="bReadOnly">
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in callCatIdOpt1"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                        <el-select v-model="form.callCatId2" placeholder="상담분류(중)" @change="onCallClassChange2" :disabled="bReadOnly" v-show="showCat2">
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in callCatIdOpt2"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                        <el-select v-model="form.callCatId3" placeholder="상담분류(소)"  @change="onCallClassChange3" :disabled="bReadOnly" v-show="showCat3">
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in callCatIdOpt3"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                        <el-select v-model="form.callCatId4" placeholder="상담분류(소)"  @change="onCallClassChange4" :disabled="bReadOnly" v-show="showCat4">
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in callCatIdOpt4"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <el-form-item label="제조사">
                        <el-input v-model="form.makerNm" readonly></el-input>
                        <el-input v-model="form.maker" v-show="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="제품군">
                        <el-input v-model="form.modelGroupNm" readonly></el-input>
                        <el-input v-model="form.modelGroup" v-show="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="대표모델">
                        <el-input v-model="form.standardModelNm" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="모델">
                        <el-input v-model="form.modelNm" readonly></el-input>
                        <el-input v-model="form.modelId" v-show="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="searchModel" v-if="!bReadOnly" v-show="showSave"></el-button>
                </el-col>
                <el-col :span="3">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="openModelSpec">
                        사양보기
                    </el-button>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="10">
                    <el-form-item label="문의내역">
                        <el-input type="textarea" v-model="form.question" :readonly="bReadOnly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="14">
                    <el-form-item label="답변내역">
                        <el-input type="textarea" v-model="form.answer" :readonly="bReadOnly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="10">
                    <el-form-item label="기타메모">
                        <el-input type="textarea" v-model="form.memo" :readonly="bReadOnly"></el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="14">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="고객명">
                                <el-input type="input" v-model.trim="form.consultCustNm" :readonly="bReadOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="연락처">
                                <el-input type="input" v-model.trim="form.consultTelNo" :readonly="bReadOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-col :span="12">
                                <el-form-item label="처리결과">
                                    <el-radio-group v-model="form.callType" :disabled="bReadOnly" @change="onCallTypeChange">
                                        <el-radio 
                                        v-for="item in callTypeRadio"
                                        :key="item.key"
                                        :label="item.key"
                                        :value="item.value">{{ item.value }}
                                    </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="상담원">
                                    <el-col :span="16">
                                        <el-input type="input" v-model.trim="form.chargeNm" disabled>
                                        </el-input>
                                        <el-input type="input" v-model.trim="form.chargeId" v-show="false"></el-input>
                                        <el-input type="input" v-model.trim="form.deptId" v-show="false"></el-input>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-button type="primary" icon="el-icon-search" @click="openModal()" v-if="!bReadOnly" v-show="showSave && form.callType === 'Default'">
                                            호전환
                                        </el-button>
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-form>
        <!-- 검색폼 e -->
        <!-- 일반상담 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `상담이력` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix" v-if="!bReadOnly">
                        <button class="btn-size btn-gray fl_left" @click="proc" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        저장
                        </button>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            :statusBar="statusBar"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 일반상담 그리드 e.-->
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

/**
 * * Modal
 */
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import CSChgModal from '@/components/AS/NormalConsult/Modal/CSChgModal.vue';
import CallReadModal from '@/components/AS/NormalConsult/Modal/CallReadModal.vue';
import ProductMenu from '@/components/AS/Receipt/Modal/ProductMenu.vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            form: {
                custNm : '',
                custType : 'Default',
                propensity : 'Default',
                propensityBigo: '', 
                positionNm: '', 
                hpNo: '', 
                officeTelNo: '', 
                etcTelNo1: '', 
                etcTelNo2: '', 
                boundTelNo: '', 
                smsYn: 'Y', 
                telYn: '',
                addr1: '',
                addr2: '',
                zipCd: '',
                zipCd1: '',
                juminNo: '',
                chargeId: '0',
                deptId: '0',
                inType: '0',
                
                callClass: '', /** 상담유형 */
                callCatId1: '', /** 상담분류(대) */
                callCatId2: '', /** 상담분류(중) */
                callCatId3: '', /** 상담분류(소) */
                callCatId4: '', /** 상담분류(소2) */
                maker: '', /** 제조사 */
                makerNm: '', /** 제조사명 */
                modelGroupNm: '', /** 모델그룹명 */
                modelGroup: '', /** 모델그룹 */
                standardModelNm: '', /** 표준모델 */
                modelNm: '', /** 모델명 */
                modelId: '', /** 모델ID */
                
                question: '', /** 문의내역 */
                answer: '', /** 답변내역 */
                memo: '', /** 기타메모 */
                consultCustNm: '', /** 고객명 */
                consultTelNo: '', /** 연락처 */
                callType: '', /** 처리결과 */
                chargeNm: '', /** 상담원 */
                catId: '', /** 최종 저장될 cat id */
                custId: ''
            },
            showSave: true, /** 저장버튼 표시여부 */
            showCat2: false, /** 상담분류2 */
            showCat3: false, /** 상담분류3 */
            showCat4: false, /** 상담분류4 */
            callClassOpt: [], /** 상담유형리스트 */
            callClassIdOpt: [], /** 상담유형리스트 Id */
            callCatIdOpt1: [], /** 상담분류(대) */
            callCatIdIdOpt1: [], /** 상담분류(대) Id */
            callCatIdOpt2: [], /** 상담분류(중) */
            callCatIdIdOpt2: [], /** 상담분류(중) Id */
            callCatIdOpt3: [], /** 상담분류(소) */
            callCatIdIdOpt3: [], /** 상담분류(소) Id */
            callCatIdOpt4: [], /** 상담분류(소) */
            callCatIdIdOpt4: [], /** 상담분류(소) Id */
            callTypeRadio: [ { "key": "Default", "value": "완료" }, { "key": "Processing", "value": "미완료" } ], /** 처리결과 */
            bReadOnly: false,  /** 비활성화 여부 */
            data: [],
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 300px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        console.log('mounted vNormalConst start===: ');
        
    },
    methods: {
        onReadyMain() { 
            //메인그리드 api 정의
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();

            this.getCombo({flag: 'INIT'});  // 단계1: 상담유형, 상담분류 셋팅. 조회
            
        },
        setSessionNormalConst(){
            //===세션정보가 있을경우 셋팅====
            const vNormalConst = JSON.parse(sessionStorage.getItem(this.$parent.asSessionKey + "normalConst"));
            console.log('setSessionNormalConst start vNormalConst ===: ', vNormalConst);
            if(vNormalConst && vNormalConst.loginId === this.$store.state.loginInfo.loginId){
                //this.callClassOpt = vNormalConst.callClassOpt || []; /** 상담유형리스트 */
                this.callClassIdOpt = vNormalConst.callClassIdOpt || []; /** 상담유형리스트 Id */
                this.callCatIdOpt1 = vNormalConst.callCatIdOpt1 || []; /** 상담분류(대) */
                this.callCatIdIdOpt1 = vNormalConst.callCatIdIdOpt1 || []; /** 상담분류(대) Id */
                this.callCatIdOpt2 = vNormalConst.callCatIdOpt2 || []; /** 상담분류(중) */
                this.callCatIdIdOpt2 = vNormalConst.callCatIdIdOpt2 || []; /** 상담분류(중) Id */
                this.callCatIdOpt3 = vNormalConst.callCatIdOpt3 || []; /** 상담분류(소) */
                this.callCatIdIdOpt3 = vNormalConst.callCatIdIdOpt3 || [];
                this.callCatIdOpt4 = vNormalConst.callCatIdOpt4 || []; /** 상담분류(소) */
                this.callCatIdIdOpt4 = vNormalConst.callCatIdIdOpt4 || [];

                if(this.callCatIdOpt2 && this.callCatIdOpt2.length>0){
                    this.showCat2 = true;
                }
                if(this.callCatIdOpt3 && this.callCatIdOpt3.length>0){
                    this.showCat3 = true;
                }
                if(this.callCatIdOpt4 && this.callCatIdOpt4.length>0){
                    this.showCat4 = true;
                }

                this.form = vNormalConst ? vNormalConst.formData : {};
                
            } else {
                if(vNormalConst){
                    sessionStorage.removeItem(this.$parent.asSessionKey + "normalConst");      // 초기화
                }
            }
        },
        async setNormalList(param){
            // search 콤포넌트에서 조회후 조회데이타를 반영하기위해 호출되는 함수

            console.log('setNormalList start param: ', param)
            const vCustObj = param ? param : this.custParam;

            this.applySearchCond(vCustObj.popHeadInfo);

            console.log('setNormalList start: ', vCustObj)
            this.enableChk(vCustObj.inType);
           
            //this.data = []
            //Object.assign(this.data, this.custParam.callAsCustSelPageList);
            //console.log('setHistoryList start this.data: ', this.data)

            let catObj = vCustObj.getCatDataByParent;
            let normalObj = vCustObj.callParamCustSelPageList || [];
            let normalListObj = vCustObj.callCustPageist || [];
            
            console.log('setNormalList normalObj: ', normalObj)
            // 조회목록에서 코드를 명칭으로 변환처리
            normalObj.map((x, i) => {

                if(x.asParentClassNm === ''){
                    x.asClass2Nm = x.asClassNm;
                }else {
                    x.asClass2Nm = x.asParentClassNm + '/' + x.asClassNm;
                }
                
                const str = x.asCatFullNm
                if (typeof str === 'string') {
                    const arr1 = str.split('>');
                    if(arr1){
                        x.asCat1LvlNm = arr1[1] || '';   // 증상구분
                    } 
                }

                let asStatusObj = catObj.filter(y => y.topKey === 'AsStatus' 
                                                            && y.catKey === x.asStatus) || [];
                if(asStatusObj && asStatusObj.length>0){
                    x.asStatusNm = asStatusObj[0].catNm || ''; // 처리결과
                }                                                            
                                 
                return x;
            })
  
            if(normalObj && normalObj.length>0){
                
                await this.$http.post(("/api/asMng/call/selectFourCat"), {catId: normalObj[0].catId}
                        ).then(response => {
                        console.log('selectFourCat: ' , response.data)
                        if(response.data){
                            const startCatLvl = response.data.startCatLvl || 0
                            
                            if(startCatLvl >= 3){
                                if(startCatLvl === 6){
                                    this.callCatIdOpt1 = response.data.cat4.map(x=>{return {key:x.catKey, value:x.catNm};});
                                    this.callCatIdOpt2 = response.data.cat3.map(x=>{return {key:x.catKey, value:x.catNm};});
                                    this.callCatIdOpt3 = response.data.cat2.map(x=>{return {key:x.catKey, value:x.catNm};});
                                    this.callCatIdOpt4 = response.data.cat1.map(x=>{return {key:x.catKey, value:x.catNm};});
                                    
                                    this.form.callClass = response.data.selCat5+''; // 상담유형
                                    this.form.callCatId1 = response.data.selCat4+''; // 상담분류1
                                    this.form.callCatId2 = response.data.selCat3+''; // 상담분류2
                                    this.form.callCatId3 = response.data.selCat2+''; // 상담분류3
                                    this.form.callCatId4 = response.data.selCat1+''; // 상담분류4

                                    
                                    const vCatParentId1 = response.data.cat4.length>0 ? response.data.cat4[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId1}})
                                    .then(response => {
                                        this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                                    });

                                    const vCatParentId2 = response.data.cat3.length>0 ? response.data.cat3[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId2}})
                                    .then(response => {
                                        this.callCatIdIdOpt2 = _.cloneDeep(response.data) || []
                                    });

                                    const vCatParentId3 = response.data.cat2.length>0 ? response.data.cat2[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId3}})
                                    .then(response => {
                                        this.callCatIdIdOpt3 = _.cloneDeep(response.data) || []
                                    });

                                    const vCatParentId4 = response.data.cat1.length>0 ? response.data.cat1[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId4}})
                                    .then(response => {
                                        this.callCatIdIdOpt4 = _.cloneDeep(response.data) || []
                                    });

                                } else if(startCatLvl === 5){
                                    this.callCatIdOpt1 = response.data.cat3.map(x=>{return {key:x.catKey, value:x.catNm};})
                                    this.callCatIdOpt2 = response.data.cat2.map(x=>{return {key:x.catKey, value:x.catNm};})
                                    this.callCatIdOpt3 = response.data.cat1.map(x=>{return {key:x.catKey, value:x.catNm};})
                                    //this.callCatIdOpt4 = response.data.cat1.map(x=>{return {key:x.catKey, value:x.catNm};})
                                    
                                    this.form.callClass = response.data.selCat4+''; // 상담유형
                                    this.form.callCatId1 = response.data.selCat3+''; // 상담분류1
                                    this.form.callCatId2 = response.data.selCat2+''; // 상담분류2
                                    this.form.callCatId3 = response.data.selCat1+''; // 상담분류3

                                    const vCatParentId1 = response.data.cat3.length>0 ? response.data.cat3[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId1}})
                                    .then(response => {
                                        this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                                    });

                                    const vCatParentId2 = response.data.cat2.length>0 ? response.data.cat2[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId2}})
                                    .then(response => {
                                        this.callCatIdIdOpt2 = _.cloneDeep(response.data) || []
                                    });
                                    
                                    const vCatParentId3 = response.data.cat1.length>0 ? response.data.cat1[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId3}})
                                    .then(response => {
                                        this.callCatIdIdOpt3 = _.cloneDeep(response.data) || []
                                    });
                                    
                                } else if(startCatLvl === 4){
                                    this.callCatIdOpt1 = response.data.cat2.map(x=>{return {key:x.catKey, value:x.catNm};})
                                    this.callCatIdOpt2 = response.data.cat1.map(x=>{return {key:x.catKey, value:x.catNm};})

                                    this.form.callClass = response.data.selCat3+''; // 상담유형
                                    this.form.callCatId1 = response.data.selCat2+''; // 상담분류1
                                    this.form.callCatId2 = response.data.selCat1+''; // 상담분류2

                                    const vCatParentId1 = response.data.cat2.length>0 ? response.data.cat2[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId1}})
                                    .then(response => {
                                        this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                                    });

                                    const vCatParentId2 = response.data.cat1.length>0 ? response.data.cat1[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId2}})
                                    .then(response => {
                                        this.callCatIdIdOpt2 = _.cloneDeep(response.data) || []
                                    });
                                    
                                    
                                } else {
                                    this.callCatIdOpt1 = response.data.cat1.map(x=>{return {key:x.catKey, value:x.catNm};})

                                    this.form.callClass = response.data.selCat2+''; // 상담유형
                                    this.form.callCatId1 = response.data.selCat1+''; // 상담분류1

                                    const vCatParentId1 = response.data.cat1.length>0 ? response.data.cat1[0].parentId : '';
                                    this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: vCatParentId1}})
                                    .then(response => {
                                        this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                                    });
                                }
                            }
                        }
                        
                    });
               
                this.form.callId = normalObj[0].callId || '';    
                this.form.catId = normalObj[0].catId || '';
                this.form.callStatus = normalObj[0].callStatus || '';
                this.form.makerNm = normalObj[0].makerNm || '';
                this.form.custId = normalObj[0].custId || '';
                //this.form.maker = normalObj[0].maker
                this.form.modelGroupNm = normalObj[0].modelGroupNm || '';
                this.form.modelGroup = normalObj[0].modelGroup || '';
                this.form.standardModelNm = normalObj[0].standardModelNm || '';
                this.form.modelNm = normalObj[0].modelNm || '';
                this.form.modelId = normalObj[0].modelId
                this.form.consultCustNm = normalObj[0].boundCustNm || '';
                
                if(this.form.inType==='IN_CALL_ID'){
                    this.form.consultTelNo = _phone(normalObj[0].callTelNo) || '';
                } else if(this.form.inType==='IN_BOUND'){
                    this.form.consultCustNm = normalObj[0].custNm || '';  
                    this.form.consultTelNo = _phone(this.form.consultTelNo) || '';
                } else {
                    this.form.consultTelNo = (this.bReadOnly ? _phone(normalObj[0].boundTelNo) : normalObj[0].boundTelNo)  || '';
                    if(this.form.consultTelNo === ''){
                        this.form.consultTelNo = _phone(normalObj[0].callTelNo) || '';
                    } else {
                        this.form.consultTelNo = _phone(this.form.consultTelNo) || '';
                    }
                }
                
                this.form.callType = normalObj[0].callType || ''; // 처리결과
                this.enableChk(vCustObj.inType);
                console.log('normalObj[0].callType kkk: ', normalObj[0].callType);
                if(normalObj[0].deptNm && normalObj[0].deptNm.length > 0){
                    this.form.chargeNm = normalObj[0].deptNm + ' > ' + normalObj[0].chargeNm; // 상담원
                    this.form.chargeId = normalObj[0].chargeId || '';
                    this.form.deptId = normalObj[0].deptId || '';
                }
                          
                this.form.question = normalObj[0].question || '';
                this.form.answer = normalObj[0].answer || '';
                this.form.memo = normalObj[0].memo || '';

                this.showCat2 = false;
                this.showCat3 = false;
                this.showCat4 = false;
                if(this.callCatIdOpt2 && this.callCatIdOpt2.length>0){
                    this.showCat2 = true;
                }
                if(this.callCatIdOpt3 && this.callCatIdOpt3.length>0){
                    this.showCat3 = true;
                }
                if(this.callCatIdOpt4 && this.callCatIdOpt4.length>0){
                    this.showCat4 = true;
                }
                
            } 
            
            this.data = normalListObj || [];
            console.log('setNormalList this.data end ', this.data)
        },
        createColumnDefs() {
            const vm = this;
            this.columnDefs = [
                {
                    headerName:'No',
                    field:'no', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                },
                {
                    headerName:'접수일자', 
                    field:'callDt', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                    cellRenderer: (params) => {
                        params.value = (params.value && params.value.length >= 19) ? params.value.substring(0,19) : (params.value || '');
                    
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                    // valueFormatter: (params) => {
                    //     return vm.getDateFormat(`${params.value}`);
                    // },
                },
                {
                    headerName:'상담유형',
                    field:'catNm', 
                    width: 160,
                    editable: false,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName:'상담분류',
                    field:'catNm', 
                    width: 160,
                    editable: false,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width: 160,
                    editable: false,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName:'문의내역',
                    field:'question', 
                    width: 350,
                    editable: false,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName:'답변내역',
                    field:'answer', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName:'처리결과',
                    field:'callStatusNm', 
                    width: 150,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'접수자',
                    field:'creatorNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
            ]
        },
        onCellClicked(params) {
            //const idx = params.rowIndex;
            console.log('normal onCellClicked : ', params)
            const field = params.colDef.field;

            if(field === 'callDt') {
                this.openModel(params.data);
            }

        },
        openModel(param) {
            /** 일반상담상세내역 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: CallReadModal,
                parent: this,
                props: {
                    data: {
                        callId: param.callId,
                        callTypeRadio: vm.callTypeRadio
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        async searchNormalList(pCustId){
            /** 상담이력 조회 */
            
            console.log('searchNormalList start this.custParam: ', this.custParam);
            let vCustId = '';

            if(pCustId){
                vCustId = pCustId;
            } else {
                if(this.custParam.callCustSelItemList && this.custParam.callCustSelItemList.length>0){
                    vCustId = this.custParam.callCustSelItemList[0].custId || ''
                    if(vCustId === ''){
                        this.data = []
                        return false
                    }
                } else {
                    this.data = []
                    return false
                }
            }
            
            const vform = {
                custId: vCustId,
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            this.$store.commit('loading')
            console.log('searchNormalList : ', vform) 
            await this.$http.post(("/api/asMng/call/selectNormalList"), vform
                ).then(response => {
                console.log('Normal select: ' , vform.inType , response.data)

                this.data = response.data.map(x=>{
                    x.callDt = (x.callDt && x.callDt.length >= 19) ? x.callDt.substring(0,19) : (x.callDt || '')
                    return x
                })
            }).finally(() => {
                this.$store.commit('finish')
            });

        },
        applySearchCond(pObj){
            // 접수관리메뉴의 상단 조회조건이 있을경우 그 값으로 셋팅
            let vObj = pObj ? pObj : this.custParam.popHeadInfo;
            
            if(vObj){
                this.form.consultCustNm = vObj.custNm; // 고객명
                
                // 휴대폰우선 차선이 일반전화. 발신번호는 제외
                let vHpNo = vObj.hpNo || '';
                if(vHpNo === ''){
                    vHpNo = vObj.telNo || '';
                }
                this.form.consultTelNo = _phone(vHpNo); // 연락처
            }
        },
        proc() {
            /** 저장처리 */

            // const vform = _.cloneDeep(this.form)
           
            if(!this.$parent.$refs.refSearchForm.custValidate()){
                // searchForm의 조회조건 체크
                return false;
            }

            const vConsultTelNo = this.form.consultTelNo.replace(/[^0-9]/g, '')

            // if(this.$parent.search.zipCd1 === ''){
            //     this.$swal({type: 'warning', text: '주소를 선택해 주십시오.'});
            //     return false
            // }

            if(this.form.callClass === ''){
                this.$swal({type: 'warning', text: '상담유형을 선택해 주십시오.'});
                return false
            }
            if(this.callCatIdOpt1.length >= 1 && this.form.callCatId1 === ''){
                this.$swal({type: 'warning', text: '상담분류를 선택해 주십시오.'});
                return false
            }
            if( (this.callCatIdOpt2.length >= 1 && this.form.callCatId2 === '') ||
                (this.callCatIdOpt3.length >= 1 && this.form.callCatId3 === '') 
            ){
                this.$swal({type: 'warning', text: '상담분류를 소분류까지 선택해 주십시오.'});
                return false
            }
            if( (this.callCatIdOpt3.length >= 1 && this.form.callCatId3 === '') ||
                (this.callCatIdOpt4.length >= 1 && this.form.callCatId4 === '') 
            ){
                this.$swal({type: 'warning', text: '상담분류를 소분류까지 선택해 주십시오.'});
                return false
            }
  
            
            if(this.form.catId === ''){
                this.$swal({type: 'warning', text: '상담분류가 올바르게 선택되지 않았습니다. 다시 선택해 주세요.'});
                return false
            }

            if(this.form.question === ''){
                this.$swal({type: 'warning', text: '문의내역을 입력해 주십시오.'});
                return false
            }
            if(this.form.answer === ''){
                this.$swal({type: 'warning', text: '답변내역을 입력해 주십시오.'});
                return false
            }
            if(this.form.callType === ''){
                this.$swal({type: 'warning', text: '처리결과를 선택해 주십시오.'});
                return false
            }
            

            // if(this.form.modelGroup === ''){
            //     this.$swal({type: 'warning', text: '제품군을 선택해 주십시오.'});
            //     return false
            // }
            
            
            
            let vZipCd = this.$parent.search.zipCd1 || '';
            let vCallId = this.custParam.hddCallId || '';
            if (vCallId === '' ){
                vCallId = this.form.callId;
            }

            let vCallStatus = ''; // 최초 등록시(insert) 프로시저에서 callType의 값으로 CallStatus 값을 얻어서 저장함. 그러나 수정시는 여기서 코드생성
            if(vCallId && vCallId != ''){
                // 이미 등록되어 수정하는 경우
                
                if(this.form.callType === 'Default'){
                    vCallStatus = 'Complete';
                } else {
                    vCallStatus = 'Receipt';
                }
            }

            const vSaveform ={
                ...this.form,
                ...this.$parent.search, /** 조회조건 */
                custNm: this.$parent.search.custNm,
                zipCd: vZipCd,
                callId : vCallId || '',
                deptId: this.form.callType === 'Default' ? this.form.deptId || '0' : '0',
                chargeId: this.form.callType === 'Default' ? this.form.chargeId || '0' : '0',
                modelId: this.form.modelId === '' ? '0' : this.form.modelId,
                consultTelNo: vConsultTelNo,
                callDt: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                actTab: 'NORMAL_TAB', /** 활성탭 */
                boundId: this.data && this.form.inType==='IN_CALL_ID' && this.data.length>0 ? this.data[0].boundId : '0',
                hddCallBoundId: this.data && this.form.inType==='IN_CALL_ID' && this.data.length>0 ? this.data[0].boundId : '0',
                callStatus: vCallStatus
            };
            
            const regex = /[^0-9]/g

            vSaveform.telNo = vSaveform.telNo ? vSaveform.telNo.replace(regex, '') : '';
            vSaveform.boundTelNo = vSaveform.boundTelNo ? vSaveform.boundTelNo.replace(regex, '') : '';
            vSaveform.hpNo = vSaveform.hpNo ? vSaveform.hpNo.replace(regex, '') : '';
            vSaveform.chargeHpNo = vSaveform.chargeHpNo ? vSaveform.chargeHpNo.replace(regex, '') : '';
            vSaveform.consultTelNo = vSaveform.consultTelNo ? vSaveform.consultTelNo.replace(regex, '') : '';
            
            if(vSaveform && !vSaveform.modelId){
                vSaveform.modelId = '0';
            }

            if(vSaveform && vSaveform.modelId==''){
                vSaveform.modelId = '0';
            }
            
            if(vSaveform && isNaN(vSaveform.modelId)){
                vSaveform.modelId = '0';
            }
            console.log('vSaveform : ', vSaveform, this.data);
            
            this.$swal({
                type: 'warning',
                text: `상담내역을 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')
                    this.$http.put(_url("/api/asMng/call/saveNormalConsult"), vSaveform)
                        .then(response => {
                            let vMsgStr = '일반상담이력이 등록되었습니다.';
                            if(response && response.data[0] == 'UPDATE_OK'){
                                vMsgStr = '일반상담이력이 수정되었습니다.';
                            }

                            this.$swal({ type: 'success', text: vMsgStr });

                            // 초기화
                            this.$parent.$refs.refSearchForm.initCust('NO_ALERT');

                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$store.commit('finish');
                        });

                }
            });

        },
        openModal() {
            let vm = this;
            this.$modal.open({
                width: 800,
                component: CSChgModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                    changeCharge(data){
                        console.log('changeCharge : ', data);
                        vm.form.deptId = data.deptId || '';
                        vm.form.chargeId = data.userId || '';
                        vm.form.chargeNm = data.deptNm + '>' + data.userNm;
                    }
                }
            });
        },
        async getCombo(param) {
            if(param.flag === 'INIT'){
                // 접수유형 : CallCat 2레벨
                const runA = this.$http.get(`/api/codeMng/combo`, {params: {parentId: 41}})
                .then(response => {
                    this.callClassOpt = response.data || []
                });

                const runB = this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 41}})
                .then(response => {
                    this.callClassIdOpt = response.data || []
                });

                this.$store.commit('loading');

                await Promise.all([runA, runB]);

                await this.setSessionNormalConst();

                await this.searchNormalList();

                if(this.custParam.applySearchCond){
                    // search 컴포넌트의 조회조건 적용 : sessionStorage보다 search변경이 우선
                    this.applySearchCond(this.custParam.applySearchCond);
                    delete this.custParam.applySearchCond;
                }

                this.$store.commit('finish');
                 

            }else if(param.flag === 'CHG0'){
                this.showCat2 = false;
                this.showCat3 = false;
                this.showCat4 = false;
                
                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt1 = _.cloneDeep(response.data) || []
                        this.form.callCatId = ''
                    });
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                });   

            }else if(param.flag === 'CHG1'){
console.log(' getCombo CHG1 :', param)
                this.showCat2 = false;
                this.showCat3 = false;
                this.showCat4 = false;
                        
                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt2 = _.cloneDeep(response.data) || [];
                        this.form.callCatId2 = '';

                        if(this.callCatIdOpt2 && this.callCatIdOpt2.length>0){
                            this.showCat2 = true;
                        }
                    });
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt2 = _.cloneDeep(response.data) || []
                });    
            }else if(param.flag === 'CHG2'){
                this.showCat3 = false;
                this.showCat4 = false;

                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt3 = _.cloneDeep(response.data) || [];
                        this.form.callCatId3 = '';

                        if(this.callCatIdOpt3 && this.callCatIdOpt3.length>0){
                            this.showCat3 = true;
                        }
                    }); 
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt3 = _.cloneDeep(response.data) || []
                    });    
            }else if(param.flag === 'CHG3'){
                this.showCat4 = false;

                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt4 = _.cloneDeep(response.data) || [];
                        this.form.callCatId4 = '';

                        if(this.callCatIdOpt4 && this.callCatIdOpt4.length>0){
                            this.showCat4 = true;
                        }
                    }); 
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt4 = _.cloneDeep(response.data) || []
                    });    
            }
        },
        onCallClassChange0(value){

            // 초기화
            // 상담분류(대)
            this.callCatIdOpt1 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt1 = JSON.parse(JSON.stringify([]))
            this.form.callCatId1 = ''

            if(this.form.callClass != '') { // 상담유형이 공백이 아닌 경우
                const vIdx = this.callClassOpt.findIndex(x=>x.key === value)
                const vParentId = this.callClassIdOpt[vIdx].key || 0

                this.getCombo({flag: 'CHG0', parentId: vParentId})
                this.form.catId = vParentId
            }

            // 초기화
            this.callCatIdOpt2 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]))
            this.form.callCatId2 = ''
            this.callCatIdOpt3 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]))
            this.form.callCatId3 = ''
            this.callCatIdOpt4 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt4 = JSON.parse(JSON.stringify([]))
            this.form.callCatId4 = ''
 
        },
        onCallClassChange1(value){

            // 초기화
            this.callCatIdOpt2 = JSON.parse(JSON.stringify([]));
            this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]));
            this.form.callCatId2 = '';

            if(this.form.callCatId1 != '') {
                const vIdx = this.callCatIdOpt1.findIndex(x=>x.key === value);
                const vParentId = this.callCatIdIdOpt1[vIdx].key || 0;

                this.getCombo({flag: 'CHG1', parentId: vParentId});
                this.form.catId = vParentId;
            } else {
                this.showCat3 = false;
                this.showCat4 = false;
                this.form.catId = '';
            }
            
            // 초기화
            this.callCatIdOpt3 = JSON.parse(JSON.stringify([]));
            this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]));
            this.form.callCatId3 = '';
            this.callCatIdOpt4 = JSON.parse(JSON.stringify([]));
            this.callCatIdIdOpt4 = JSON.parse(JSON.stringify([]));
            this.form.callCatId4 = '';
        },
        onCallClassChange2(value){

            const vIdx = this.callCatIdOpt2.findIndex(x=>x.key === value);
            if(vIdx == -1){
                this.showCat4 = false;
                this.form.catId = '';

                this.callCatIdOpt3 = JSON.parse(JSON.stringify([]));
                this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]));
                this.form.callCatId3 = '';
                
            } else {
                const vParentId = this.callCatIdIdOpt2[vIdx].key || 0;

                this.getCombo({flag: 'CHG2', parentId: vParentId});
                this.form.catId = vParentId;
            }
            
            // 초기화
            this.callCatIdOpt4 = JSON.parse(JSON.stringify([]));
            this.callCatIdIdOpt4 = JSON.parse(JSON.stringify([]));
            this.form.callCatId4 = '';
        },
        onCallClassChange3(value){

            const vIdx = this.callCatIdOpt3.findIndex(x=>x.key === value);
            if(vIdx == -1){
                this.form.catId = '';

                // 초기화
                this.callCatIdOpt4 = JSON.parse(JSON.stringify([]));
                this.callCatIdIdOpt4 = JSON.parse(JSON.stringify([]));
                this.form.callCatId4 = '';
            } else {
                const vParentId = this.callCatIdIdOpt3[vIdx].key || 0;
             
                this.getCombo({flag: 'CHG3', parentId: vParentId});
                this.form.catId = vParentId;
            }
            
        },
        onCallClassChange4(value){

        const vIdx = this.callCatIdOpt4.findIndex(x=>x.key === value);
        const vParentId = this.callCatIdIdOpt4[vIdx].key || 0;
        
        this.form.catId = vParentId;
        },
        searchModel(){
            /** 모델선택 */
            let vm = this;
            this.$modal.open({
                width: 800,
                component: ModelSelectModal,
                parent: this,
                props: {
                    data: {
                        custId : this.form.custId ? this.form.custId : '0'
                    },
                },
                events: {
                    close(param) {
                        console.log('close', param);
                        vm.form.maker = param.data.maker /** 제조사 */
                        vm.form.makerNm = param.data.makerNm /** 제조사명 */
                        vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                        vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
                        vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
                        vm.form.modelNm = param.data.modelNm /** 모델명 */
                        vm.form.modelId = param.data.modelId /** 모델ID */
                    },
                }
            });

        },
        enableChk(param){
            /** 입력항목 활성화처리 */
            console.log('enableChk start :', param);
            this.showSave = true;

            this.form.inType = param;

            if(param === 'IN_CALL_ID'){
                if(this.form.callType === 'Processing'){
                    // 처리결과가 미완료이면 수정가능해야 함.
                    this.bReadOnly = false;
                } else {
                    this.bReadOnly = true;
                }
            } else if(param === 'IN_AS_ID'){
                this.showSave = false; // 저장버튼 숨김.
            } else {
                this.bReadOnly = false;
            }
        },
        /**
         * 모델 사양 팝업 오픈
         * * 그리드 상 모델 선택시 오픈되어지는 모델 사양
         */
         openModelSpec(param) {
            
            const vForm = {
                modelGroup: this.form.modelGroup,
                modelCd : this.form.modelNm
            };
             
            this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {data: vForm}});

        },
        onCallTypeChange(param){
            // 처리결과 변경시
            if(param !== 'Default'){
                this.form.deptId = '0';
                this.form.chargeId = '0';
                this.form.chargeNm = '';
            }

        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>